export default __webpack_public_path__ + "static/media/communication_specialists_set_up_a_satellite_in_mali.0fafdb9f.jpg";